import { render, staticRenderFns } from "./AppMenus.vue?vue&type=template&id=25e72070&scoped=true&"
import script from "./AppMenus.vue?vue&type=script&lang=js&"
export * from "./AppMenus.vue?vue&type=script&lang=js&"
import style0 from "./AppMenus.vue?vue&type=style&index=0&id=25e72070&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e72070",
  null
  
)

export default component.exports